import { Observable, of } from 'rxjs';
import { INotificationGroup } from '../dtos/responses/notification-group.model';
import { INotificationGroupsClient } from './i-notification-groups.client';
import { SystemRoleEnum } from '../../../../user-management/system-management/system-roles/enums/role-type.enum';
import { adminNotificationGroups, notificationGroups } from '../data/notification-groups.data';
import { inject, Injectable } from '@angular/core';
import { AuthenticationService } from '../../../../user-management/auth-management/authentication/services/authentication.service';
import { UserContextService } from '../../../../user-management/auth-management/authentication/services/user-context.service';

@Injectable({
    providedIn: 'root'
})
export class NotificationGroupssInMemoryClient implements INotificationGroupsClient {
    authenticationService = inject(AuthenticationService);

    getByRoles(roles: string[]): Observable<INotificationGroup[]> {
        let token = this.authenticationService.ensureAuthenticated();

        if (!token) {
            return of([]);
        }

        if (UserContextService.hasSystemRole(SystemRoleEnum.SYSTEM_GLOBAL_ADMIN)) {
            return of(adminNotificationGroups);
        }

        return of(notificationGroups.filter(group => roles.some(role => group.name.includes(role))));
    }
}
